import React, { useState } from "react";
import toast from "react-hot-toast";
import api from "../../api/Api.js";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";

const AddTagsPage = () => {

  const navigate = useNavigate();

  // =========================
  // STATE (TAGS)
  // =========================

  const [tagRows, setTagRows] = useState([
    {
      tagName: "",
      slug: ""
    }
  ]);

  // =========================
  // ADD ROW
  // =========================

  const addTagRow = () => {
    setTagRows([
      ...tagRows,
      {
        tagName: "",
        slug: ""
      }
    ]);
  };

  // =========================
  // REMOVE ROW
  // =========================

  const removeTagRow = async (index) => {

    if (tagRows.length === 1) {
      toast.error("At least one row required");
      return;
    }

    const confirm = await Swal.fire({
      title: "Delete Row?",
      icon: "warning",
      showCancelButton: true
    });

    if (!confirm.isConfirmed) return;

    const updated = tagRows.filter((_, i) => i !== index);
    setTagRows(updated);
  };

  // =========================
  // HANDLE INPUT CHANGE
  // =========================

  const handleTagChange = (index, field, value) => {

    const updatedRows = [...tagRows];

    updatedRows[index][field] = value;

    // AUTO SLUG GENERATE
    if (field === "tagName") {
      updatedRows[index].slug = value
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-");
    }

    setTagRows(updatedRows);
  };

  // =========================
  // SAVE TAGS
  // =========================

  const saveTags = async () => {

    const hasEmpty = tagRows.some(row => !row.tagName);

    if (hasEmpty) {
      toast.error("Tag Name is required");
      return;
    }

    const confirm = await Swal.fire({
      title: "Save Tags?",
      text: "Do you want to save these tags?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes Save"
    });

    if (!confirm.isConfirmed) return;

    try {

      const payload = {
        tags: tagRows
      };

      const res = await api.post("/adminBlog/saveTags", payload);

      if (res.data.success) {

        Swal.fire("Success", "Tags Saved Successfully", "success");

        setTagRows([
          {
            tagName: "",
            slug: ""
          }
        ]);

        navigate("/tags/manage-tags");

      } else {
        Swal.fire("Error", res.data.message, "error");
      }

    } catch (error) {
      console.log("ERROR =>", error?.response?.data);
      toast.error(error?.response?.data?.message || "Server Error");
    }
  };

  // =========================
  // UI
  // =========================

  return (
    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}
      <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">
        <div className="card-body d-flex justify-content-between align-items-center">
          <h4 className="fw-bold mb-0">Add Tags</h4>

          <Link
            to="/tags/manage-tags"
            className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
          >
            <ArrowLeft size={16} />
            Back
          </Link>
        </div>
      </div>

      {/* TABLE */}
      <div className="card shadow-sm border-0">
        <div className="card-body">

          <table className="table table-hover table-bordered align-middle mb-0">

            <thead className="table-light">
              <tr>
                <th width="50">Sl.No</th>
                <th>Tag Name</th>
                <th>Slug</th>
                <th width="120">Action</th>
              </tr>
            </thead>

            <tbody>

              {tagRows.map((row, index) => (
                <tr key={index}>

                  <td>{index + 1}</td>

                  {/* TAG NAME */}
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Tag Name"
                      value={row.tagName}
                      onChange={(e) =>
                        handleTagChange(index, "tagName", e.target.value)
                      }
                    />
                  </td>

                  {/* SLUG */}
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Slug"
                      value={row.slug}
                      onChange={(e) =>
                        handleTagChange(index, "slug", e.target.value)
                      }
                    />
                  </td>

                  {/* ACTION */}
                  <td>
                    <button
                      type="button"
                      className="btn btn-success btn-sm me-2"
                      onClick={addTagRow}
                    >
                      <i className="fa fa-plus-square"></i>
                    </button>

                    <button
                      type="button"
                      className="btn btn-danger btn-sm"
                      onClick={() => removeTagRow(index)}
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </td>

                </tr>
              ))}

            </tbody>

          </table>

        </div>
      </div>

      {/* SAVE BUTTON */}
      <div className="text-center">
        <button
          className="btn btn-info text-white px-5 mt-3"
          onClick={saveTags}
        >
          Save Tags
        </button>
      </div>

    </div>
  );
};

export default AddTagsPage;